// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"ca869461","513":"dd071069","703":"aebb34cd","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};